export default __webpack_public_path__ + "static/media/commulino-color.c824f8de.svg";